import {all} from 'redux-saga/effects';

import init from './init.saga';
import basket from './basket.saga';
import order from './order.saga';
import search from './search.saga';
import relatedProducts from './relatedProducts.saga';
import searchMore from './searchMore.saga';
import searchSuggestions from './searchSuggestions.saga';
import productDetail from './productDetail.saga';
import offers from './offers.saga';
import branchList from './branchList.saga';
import branch from './branch.saga';
import lookup from './lookup.saga';
import checkout from './checkout.saga';
import recommended from './recommended.saga';
import slots from './slots.saga';
import auth from './auth.saga';
import account from './account.saga';
import favourite from './favourites.saga';
import previouslyPurchased from './previouslyPurchased.saga';
import upselling from './upselling.saga';
import settings from './settings.saga';
import vacancies from './vacancies.saga';
import marketingOptions from './marketingOptions.saga';
import updateBasket from './updateBasket.saga';
import updateBasketItem from './updateBasketItem.saga';
import boxes from './boxes.saga';
import getCmsData from './cms.saga';
import shoppingList from './shoppingLists.saga';
import email from './email.saga';
import pbbBankDetails from './pbbBankDetails.saga';
import blog from './blog.saga';
import jjContent from './jjContent.saga';
import searchCategoryDescription from './searchCategoryDescription.saga';
import completeProfile from './completeProfile.saga';
import reportToken from './reportToken.saga';
import invoiceUpload from './invoiceUpload.saga';
import invoiceRegistration from './invoiceRegistration.saga';
import reviews from './reviews.saga';
import orderFeedback from './orderFeedback.saga';
import creditTerms from './creditTerms.saga';
import halalBestSellers from './halalBestSellers.saga';

export default function* saga() {
  yield all([
    account(),
    auth(),
    basket(),
    blog(),
    boxes(),
    email(),
    init(),
    getCmsData(),
    updateBasket(),
    updateBasketItem(),
    branch(),
    branchList(),
    checkout(),
    favourite(),
    halalBestSellers(),
    lookup(),
    jjContent(),
    offers(),
    order(),
    pbbBankDetails(),
    previouslyPurchased(),
    productDetail(),
    recommended(),
    reportToken(),
    search(),
    relatedProducts(),
    searchMore(),
    searchSuggestions(),
    settings(),
    shoppingList(),
    slots(),
    upselling(),
    vacancies(),
    marketingOptions(),
    searchCategoryDescription(),
    completeProfile(),
    invoiceUpload(),
    invoiceRegistration(),
    reviews(),
    orderFeedback(),
    creditTerms(),
  ]);
}
